<template>
  <div id="app" class="app-container">
    <MainNavbar ref="navbar" />
    
    <!-- Zone principale qui prend l'espace disponible -->
    <main class="main-content">
      <router-view :navbar-height="navbarHeight" />
    </main>

    <MainFooter />
  </div>
</template>

<script>
import MainNavbar from './components/MainNavbar.vue';
import MainFooter from './components/MainFooter.vue';

export default {
  name: 'App',
  components: {
    MainNavbar,
    MainFooter,
  },
  data() {
    return {
      navbarHeight: 0,
    };
  },
  mounted() {
    this.updateNavbarHeight();
    window.addEventListener('resize', this.updateNavbarHeight);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateNavbarHeight);
  },
  methods: {
    updateNavbarHeight() {
      this.$nextTick(() => {
        const navbar = this.$refs.navbar?.$el;
        if (navbar) {
          this.navbarHeight = navbar.offsetHeight;
        }
      });
    },
  },
};
</script>

<style>
/* Étendre sur toute la hauteur */
/* html, body, #app {
  height: 100%;
  margin: 0;
} */

/* Conteneur principal en flex */
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow: visible;
}

/* Le contenu prend tout l'espace restant entre la navbar et le footer */
.main-content {
  flex: 1;
  overflow: visible;
}
</style>
